import React from "react"
import Typography from '@mui/material/Typography';


export const TextInsulin = () => {

return(
<div>

Insulin resistance is the primary pathophysiology underlying metabolic syndrome
and type 2 diabetes1,2. Previous metagenomic studies have described the
characteristics of gut microbiota and their roles in metabolizing major nutrients in
insulin resistance. <br /><br />

In particular, carbohydrate metabolism of commensals has been
proposed to contribute up to 10% of the host’s overall energy extraction, thereby
playing a role in the pathogenesis of obesity and prediabetes.<br /><br />

In a study unbiased faecal metabolomics was combined with metagenomics, host metabolomics and transcriptomics data to
profile the involvement of the microbiome in insulin resistance. <br /><br />

These data reveal that
faecal carbohydrates, particularly host-accessible monosaccharides, are increased in
individuals with insulin resistance and are associated with microbial carbohydrate
metabolisms and host inflammatory cytokines. We identify gut bacteria associated
with insulin resistance and insulin sensitivity that show a distinct pattern of
carbohydrate metabolism, and demonstrate that insulin-sensitivity-associated
bacteria ameliorate host phenotypes of insulin resistance in a mouse model. Our
study, which provides a comprehensive view of the host–microorganism relationships
in insulin resistance, reveals the impact of carbohydrate metabolism by microbiota,
suggesting a potential therapeutic target for ameliorating insulin resistance.

<br /><br />

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Mechanisms linking gut microbial metabolites to insulin resistance: </Typography>
<br /><br />

Insulin resistance is the rate-limiting step in the development of metabolic diseases, including type 2 diabetes. 
The gut microbiota has been implicated in host energy metabolism and metabolic diseases and is recognized as a quantitatively important organelle in host metabolism, 
as the human gut harbors 10 trillion bacterial cells. <br /><br />

Gut microbiota break down various nutrients and produce metabolites that play fundamental roles in host metabolism and aid 
in the identification of possible therapeutic targets for metabolic diseases. Therefore, understanding the various effects of 
bacterial metabolites in the development of insulin resistance is critical. In a study was reviewed the mechanisms linking gut microbial metabolites 
to insulin resistance in various insulin-responsive tissues.

</div>
)
}